import * as React from "react"
import styled from "styled-components"

import GithubButton from "./gitButton"
import { graphql, useStaticQuery } from "gatsby"
import ImageGrid from "./imageGrid"
import CustomLink from "./customLink"

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;
  text-align: left;
  gap: 16px;
  margin-bottom: 16px;
  & h2 {
    margin-bottom: 0;
  }
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 48px;
  & p {
    margin: 0;
  }
  @media (min-width: 768px) {
    gap: 40px;
    margin-bottom: 56px;
  }
`
const StyledGithubBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  gap: 0.5rem;

  @media (min-width: 768px) {
    justify-content: flex-end;
  }
`

const ATLASSIAN_LOGO =
  "https://webimages.mongodb.com/_com_assets/cms/kyylk6satz8mymkgh-Atlassian-horizontal-blue-rgb%201.svg?auto=format%252Ccompress"
const THL_LOGO =
  "https://webimages.mongodb.com/_com_assets/cms/kyylyy1psymjpzdx0-THLDigital.svg?auto=format%252Ccompress"
const IMGUR_LOGO =
  "https://webimages.mongodb.com/_com_assets/cms/kyylzfs28l4ut3vrq-Imgur_logo%201.png?auto=format%252Ccompress"
const CBT_LOGO =
  "https://webimages.mongodb.com/_com_assets/cms/kyym0dlk7azg4g067-CBT%20Nuggets.svg?auto=format%252Ccompress"
const COX_LOGO =
  "https://webimages.mongodb.com/_com_assets/cms/kyym13chv1jx39n2w-Cox-Automotive.svg?auto=format%252Ccompress"
const HUMANITIX_LOGO =
  "https://webimages.mongodb.com/_com_assets/cms/kyym1xhdvjrulseke-Humantix.svg?auto=format%252Ccompress"
const SEVENELEVEN_LOGO =
  "https://webimages.mongodb.com/_com_assets/cms/kyym2r3gcwax9u5ej-7-Eleven.svg?auto=format%252Ccompress"
const CUE_LOGO =
  "https://webimages.mongodb.com/_com_assets/cms/kyym3bxhbs4loo01y-Vector.svg?auto=format%252Ccompress"

const logos = [
  { logo: ATLASSIAN_LOGO, alt: "Atlassian" },
  { logo: THL_LOGO, alt: "THL" },
  { logo: IMGUR_LOGO, alt: "Imgur" },
  { logo: CBT_LOGO, alt: "CBT Nuggets" },
  { logo: COX_LOGO, alt: "Cox Automotive" },
  { logo: HUMANITIX_LOGO, alt: "Humanitix" },
  { logo: SEVENELEVEN_LOGO, alt: "7-Eleven" },
  { logo: CUE_LOGO, alt: "Cue" },
]

const SocialProof = ({ brands, header, github, content }) => {
  const data = useStaticQuery(graphql`
    query {
      allGithubCounter {
        edges {
          node {
            forks
            stars
          }
        }
      }
    }
  `)

  const cards = logos.map(logo => <img alt={logo.alt} src={logo.logo} />)
  const filteredCards = cards.filter(card => brands.includes(card.alt))

  return (
    <>
      <StyledHeader>
        <h2>{header}</h2>
        {github && (
          <StyledGithubBar>
            <GithubButton
              type="fork"
              data={data.allGithubCounter.edges[0].node}
            />
            <GithubButton
              type="star"
              data={data.allGithubCounter.edges[0].node}
            />
          </StyledGithubBar>
        )}
      </StyledHeader>
      <ContentWrapper>
        {content}
        <CustomLink href="/community-projects" text="View Community Projects" />
      </ContentWrapper>

      <ImageGrid
        cards={brands === "all" ? cards : filteredCards}
        border
        background="rgba(241, 240, 252, 0.35)"
        cardWidth="240"
        maxWidth={1160}
      />
    </>
  )
}
export default SocialProof
